'use client';

import { useTranslations } from '@dealerportal/i18n/client';
import { BetterButton } from '@dealerportal/ui-components/BetterButton';
import type React from 'react';
import { useState } from 'react';

interface DownloadLinkProps {
  files: { label: string; file: string }[];
}

export const DownloadLink: React.FC<DownloadLinkProps> = ({ files }) => {
  const t = useTranslations('products');
  const [isOpen, setIsOpen] = useState(false);
  const baseUrl = 'https://images.floorforce.com/Textures/';

  // Create translation mapping for file labels
  const getLabelTranslation = (label: string) => {
    if (label === 'Brochure') return t('brochure');
    if (label === 'Warranty') return t('warranty');
    return label;
  };

  return (
    <div className="ui-relative ui-max-w-max ui-mt-3">
      <BetterButton
        className="ui-p-2 ui-font-semibold"
        btnStyle="simple"
        icon={`
          <svg class="${isOpen ? 'ui-rotate-90' : ''}" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg>  
        `}
        iconSize="2"
        iconClassName="ui-order-1"
        label={t('downloadableResources')}
        labelClassName="ui-text-sm"
        attributes={{
          onClick: () => setIsOpen(!isOpen),
          'aria-expanded': isOpen,
        }}
      />
      {isOpen && (
        <div className="ui-absolute ui-top-full ui-right-2 ui-w-44 ui-mt-px ui-p-2 ui-bg-white ui-shadow-lg">
          {files.map(({ label, file }, index) => (
            <a
              key={index}
              href={
                file.startsWith('http://') || file.startsWith('https://')
                  ? file
                  : `${baseUrl}${file}`
              }
              target="_blank"
              rel="noopener noreferrer"
              className="ui-flex ui-gap-2 ui-items-center ui-p-2 ui-text-sm ui-text-gray-800 hover:ui-bg-gray-100 focus:ui-outline-none focus:ui-bg-gray-100 ui-font-sans"
            >
              <svg
                className="ui-w-4 ui-fill-gray-950"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 512 512"
              >
                <path d="M64 464l48 0 0 48-48 0c-35.3 0-64-28.7-64-64L0 64C0 28.7 28.7 0 64 0L229.5 0c17 0 33.3 6.7 45.3 18.7l90.5 90.5c12 12 18.7 28.3 18.7 45.3L384 304l-48 0 0-144-80 0c-17.7 0-32-14.3-32-32l0-80L64 48c-8.8 0-16 7.2-16 16l0 384c0 8.8 7.2 16 16 16zM176 352l32 0c30.9 0 56 25.1 56 56s-25.1 56-56 56l-16 0 0 32c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-48 0-80c0-8.8 7.2-16 16-16zm32 80c13.3 0 24-10.7 24-24s-10.7-24-24-24l-16 0 0 48 16 0zm96-80l32 0c26.5 0 48 21.5 48 48l0 64c0 26.5-21.5 48-48 48l-32 0c-8.8 0-16-7.2-16-16l0-128c0-8.8 7.2-16 16-16zm32 128c8.8 0 16-7.2 16-16l0-64c0-8.8-7.2-16-16-16l-16 0 0 96 16 0zm80-112c0-8.8 7.2-16 16-16l48 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 32 32 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-32 0 0 48c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-64 0-64z" />
              </svg>

              {getLabelTranslation(label)}
            </a>
          ))}
        </div>
      )}
    </div>
  );
};
